module.exports = __webpack_public_path__ + "static/media/relaxed_casual_2.db8a1b9a.svg";